import type { NextPage } from "next";
import Head from "next/head";
import Image from "next/image";
import styles from "styles/Home.module.css";
import Layout from "components/layout";
import About from "components/about";
import Login from "./login";
import javascript from "image/javascript.png";
import mongodb from "image/mongodb.png";
import express from "image/expressjs.png";
import react from "image/react.png";
import node from "image/node.webp";
import Lottie from "react-lottie";
import animationData from "../utils/step-loader.json";
import backendBlue from "../utils/backend-blue.json";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import useDarkMode from "use-dark-mode";
import NightsStayIcon from "@material-ui/icons/NightsStay";
import FlareIcon from "@material-ui/icons/Flare";
import MUILink from "@material-ui/core/Link";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
  homeLottie: {
    // position: "absolute",
    // marginLeft: "45rem",
  },
}));

const MainContent = () => {
  const classes = useStyles();
  const siteOptions = {
    loop: true,
    autoplay: true,
    animationData: backendBlue,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const { value: isDark, toggle: toggleDarkMode } = useDarkMode();
  return (
    <>
      <div className={classes.root}>
        {/* <MUILink
          style={
            isDark
              ? { textDecoration: "none", color: "white" }
              : { textDecoration: "none", color: "black" }
          }
          onClick={toggleDarkMode}
        >
          {isDark ? <FlareIcon /> : <NightsStayIcon />}
        </MUILink> */}
        <Grid container>
          <Grid item sm={6}>
            <h2 className={`${styles.description} text-shadow`}>
              👨‍💻 Web Developer
            </h2>
          </Grid>
          <Grid item sm={6} className={classes.homeLottie}>
            {/* lotties */}
            <Lottie options={siteOptions} width={200} />
          </Grid>
        </Grid>
      </div>
      <About />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <h3>
          💡 <u className="text-shadow">Technology Stack</u> 💡
        </h3>
      </div>
      <div className={styles.grid}>
        <div
          className={styles.card}
          data-aos="fade-right"
          data-aos-anchor-placement="bottom-bottom"
        >
          <div className="stack-image">
            <Image
              className="stack-inner-image"
              src={javascript}
              width="100%"
              height="100%"
              layout="responsive"
              objectFit="contain"
              alt="javascript"
            />
          </div>
          <h3>Javascript</h3>
        </div>
        <div
          className={styles.card}
          data-aos="fade-right"
          data-aos-anchor-placement="bottom-bottom"
        >
          <div className="stack-image">
            <Image
              className="stack-inner-image"
              src={mongodb}
              width="100%"
              height="100%"
              layout="responsive"
              objectFit="contain"
              alt="mongodb"
            />
          </div>
          <h3>MongoDB</h3>
        </div>

        <div
          className={styles.card}
          data-aos="fade-up"
          data-aos-anchor-placement="bottom-bottom"
        >
          <div className="stack-image">
            <Image
              className="stack-inner-image"
              src={express}
              width="100%"
              height="100%"
              layout="responsive"
              objectFit="contain"
              alt="express"
            />
          </div>
          <h3>Express Js</h3>
        </div>

        <div
          className={styles.card}
          data-aos="fade-left"
          data-aos-anchor-placement="bottom-bottom"
        >
          <div className="stack-image">
            <Image
              className="stack-inner-image"
              src={react}
              width="100%"
              height="100%"
              layout="responsive"
              objectFit="contain"
              alt="mongodb"
            />
          </div>
          <h3>React Js</h3>
        </div>

        <div
          className={styles.card}
          data-aos="fade-left"
          data-aos-anchor-placement="bottom-bottom"
        >
          <div className="stack-image">
            <Image
              className="stack-inner-image"
              src={node}
              width="100%"
              height="100%"
              layout="responsive"
              objectFit="contain"
              alt="mongodb"
            />
          </div>
          <h3>Node Js</h3>
        </div>
      </div>
      {/* <div className="loader-center">
        <div className="loader-wrapper">
          <div className="loader">
            <div className="loader loader-inner"></div>
          </div>
        </div>
      </div> */}
    </>
  );
};

const Home: NextPage = () => {
  return (
    <div className={styles.container}>
      <Head>Keyur Italiya</Head>

      <main className={styles.main}>
        {true ? (
          <Layout>
            {" "}
            <MainContent />{" "}
          </Layout>
        ) : (
          <Layout>
            <Login />
          </Layout>
        )}
      </main>
    </div>
  );
};

export default Home;
